import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { InfoCard } from '@backstage/core-components';
import { ModelReleaseCard } from './ModelReleaseCard';
import { latestReleases } from '../data/externalArticles';

const useStyles = makeStyles(_theme => ({
  infoCard: {
    height: '100%',
  },
}));

export const LatestReleasesSection = () => {
  const classes = useStyles();

  return (
    <InfoCard
      title="Latest Model Releases"
      subheader="Recent major LLM releases and their key capabilities"
      className={classes.infoCard}
    >
      <Grid container spacing={2}>
        {latestReleases.map(release => (
          <Grid item xs={12} sm={6} md={4} key={release.url}>
            <ModelReleaseCard release={release} />
          </Grid>
        ))}
      </Grid>
    </InfoCard>
  );
};
